import { database } from '../firebase';
import { ref, set, get } from 'firebase/database';
import { auth } from '../firebase';

// Default structure for class organization
export const createDefaultOrganization = () => ({
    period1: [],
    period2: [],
    period3: [],
    period4: [],
    period5: [],
    period6: [],
    period7: [],
    other: [],
    unassigned: []
});

// Save organization to localStorage
export const saveToLocalStorage = (organization) => {
    localStorage.setItem('classOrganization', JSON.stringify(organization));
    console.log('✅ Class organization saved to localStorage');
};

// Load organization from localStorage
export const loadFromLocalStorage = () => {
    const saved = localStorage.getItem('classOrganization');
    if (saved) {
        try {
            return JSON.parse(saved);
        } catch (error) {
            console.error('Error parsing class organization:', error);
            return null;
        }
    }
    return null;
};

// Save organization to Firebase
export const saveToFirebase = async (organization) => {
    if (!auth.currentUser) {
        console.log('Cannot save: No Firebase user');
        return false;
    }

    try {
        const userId = auth.currentUser.uid;
        const dataRef = ref(database, `users/${userId}/classOrganization`);
        await set(dataRef, organization);
        console.log('✅ Class organization saved to Firebase');
        return true;
    } catch (error) {
        console.error('Error saving to Firebase:', error);
        return false;
    }
};

// Load organization from Firebase
export const loadFromFirebase = async () => {
    if (!auth.currentUser) {
        console.log('Cannot load: No Firebase user');
        return null;
    }

    try {
        const userId = auth.currentUser.uid;
        const dataRef = ref(database, `users/${userId}/classOrganization`);
        const snapshot = await get(dataRef);

        if (snapshot.exists()) {
            console.log('✅ Class organization loaded from Firebase');
            return snapshot.val();
        }
        return null;
    } catch (error) {
        console.error('Error loading from Firebase:', error);
        return null;
    }
};

// Create class items from Google Classroom and Canvas
export const createClassItems = (googleClasses, canvasEvents, canvasCourses = []) => {
    const items = [];

    // Add Google Classroom courses
    if (googleClasses?.length) {
        googleClasses.forEach(course => {
            const courseId = course.id || course.courseId;
            if (!courseId) return;

            items.push({
                id: `google-${courseId}`,
                type: 'google',
                name: course.name,
                courseId,
                assignmentCount: Array.isArray(course.upcomingWork)
                    ? course.upcomingWork.filter(w => !w.completed).length
                    : 0
            });
        });
    }

    // Use passed-in canvasCourses prop
    canvasCourses.forEach(course => {
        items.push({
            id: `canvas-${course.id}`,
            type: 'canvas',
            name: course.name,
            courseId: course.id,
            courseUrl: course.courseUrl,
            assignmentCount: canvasEvents?.filter(e => e.courseId === course.id).length || 0
        });
    });

    return items;
};

// Get period name from schedule
export const getPeriodName = (periodNumber, schedule, organization) => {
    if (!schedule || !schedule.scheduleType) return `Period ${periodNumber}`;

    // Check if this period has assigned classes
    const assignedClasses = organization[`period${periodNumber}`];
    if (!assignedClasses || assignedClasses.length === 0) {
        return `Period ${periodNumber}`;
    }

    // Get the first assigned class name
    const firstClass = assignedClasses[0];
    return firstClass.name || `Period ${periodNumber}`;
};